<template>
  <v-layout column v-if="currentSection">
    <v-layout
      column
      v-if="
        currentSection.tax_return && currentSection.tax_return.status === 'sent'
      "
    >
      <div>
        Please click the button below to review & sign form 8879. You will then
        be able to download your draft tax return.
      </div>
      <v-btn
        outline
        class="primary--text text-none"
        @click="
          $router.push(
            `/tax-return-delivery/${currentSection.tax_return.id}?companyId=${currentCompany.id}`,
          )
        "
      >
        Start
      </v-btn>
    </v-layout>
    <v-layout column v-else>
      <div class="ma-2">
        Please hang on tight while we prepare your tax return. You will be
        notified when it is ready for your review.
      </div>
      <v-icon class="primary--text" size="50">access_time</v-icon>
    </v-layout>
  </v-layout>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import { mapGetters } from 'vuex';
import API from '@/api';
import moment from 'moment';

export default {
  props: {
    currentQuestionnaire: {
      type: Object,
    },
    currentSection: {
      type: Object,
    },
    currentCompany: {
      type: Object,
    },
  },

  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      currentUser: 'user',
      currentFirm: 'currentFirm',
    }),
  },
  methods: {
    isEmpty,

    moment,
  },
};
</script>

<style lang="postcss" scoped></style>
